import { useAvailableFiltersQuery } from 'clientState/providers/ParsedSearchResponseProvider';
import React, { useContext, useEffect, useRef } from 'react';

const identity = (x) => x;

const createStateProvider = (
  filterName,
  Context,
  toInitialState = identity
) => {
  const useAvailableFilterState = () => {
    const { data } = useAvailableFiltersQuery();
    return data?.[filterName] || null;
  };

  const useInternalFilterState = (filterState) => {
    const availableFilterState = useAvailableFilterState();
    const previousInitialFilterStateRef = useRef();

    useEffect(() => {
      previousInitialFilterStateRef.current = availableFilterState;
    }, [availableFilterState]);

    const isNewSearch =
      !previousInitialFilterStateRef.current || !availableFilterState;

    if (isNewSearch) {
      return toInitialState(availableFilterState, { isNewSearch });
    }

    return filterState || toInitialState(availableFilterState);
  };

  const StateProvider = (props) => {
    const filterState = useInternalFilterState(props[filterName]);
    return (
      <Context.Provider value={filterState}>{props.children}</Context.Provider>
    );
  };

  const useFilterState = () => useContext(Context);

  return {
    StateProvider,
    useFilterState,
    useAvailableFilterState,
  };
};

export default createStateProvider;
